import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { toLocalIsoOrNull } from '../../../../utils/date.utils';

interface DialogData {
  block: any;
  staffName: string;
}

@Component({
    selector: 'app-block-dialog',
    templateUrl: './block-dialog.component.html',
    styleUrls: ['./block-dialog.component.css'],
    standalone: false
})
export class BlockDialogComponent implements OnInit {
  blockForm: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<BlockDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm(): void {
    this.blockForm = this.fb.group({
      startAt: [this.data.block ? this.formatDateTime(this.data.block.startAt) : '', Validators.required],
      endAt: [this.data.block ? this.formatDateTime(this.data.block.endAt) : '', Validators.required],
      reason: [this.data.block ? this.data.block.reason : '', Validators.maxLength(500)],
      isActive: [this.data.block ? this.data.block.isActive : true]
    });
  }

  private formatDateTime(dateTime: string): string {
    if (!dateTime) return '';
    const date = new Date(dateTime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes;
  }

  onSave(): void {
    if (this.blockForm.valid) {
      const formValue = this.blockForm.value;
      
      const transformedValue = {
        startAt: this.formatDateTimeToISO(formValue.startAt),
        endAt: this.formatDateTimeToISO(formValue.endAt),
        reason: formValue.reason || null,
        isActive: formValue.isActive
      };
      
      this.dialogRef.close(transformedValue);
    } else {
      this.markFormGroupTouched(this.blockForm);
    }
  }

  private formatDateTimeToISO(value: any): string | null {
    // Hora local de la location, sin 'Z' ni offset.
    return toLocalIsoOrNull(value);
  }

  private markFormGroupTouched(formGroup: UntypedFormGroup): void {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      control.markAsTouched();
    });
  }
}
